import React from 'react';

function MyThema() {
  return (
    <div className='flex content-center items-center justify-center h-full w-full bg-white shadow float-right -mr-6 desktopview'>
      <div className='relative flex flex-col min-w-0 break-words w-full p-10'>
        <div className='center-styl text-xs text-color-btn font-semibold mb-2'>
          Meine Themen
        </div>

        <div className='flex flex-row my-2'>
          <img
            id='output'
            src='https://ui-avatars.com/api/?name=John+Doe'
            className='w-10 h-10 rounded-full object-cover'
            alt=''
          />

          <div className='text-xs font-semibold text-black m-2'>Name</div>
        </div>
      </div>
    </div>
  );
}

export default MyThema;
